import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink} from "@angular/router";
import {env} from "../../../../environments/environment";
import {NAVS} from "../../../constants/navs";
import {APP_ROUTES} from '../../../constants/routes';
import {Template} from "../../../interfaces/template";
import {SeoService} from "../../../services/seo.service";

@Component({
    selector: 'app-agreement-page',
    imports: [
        RouterLink
    ],
    templateUrl: './agreement-page.component.html',
    standalone: true,
    styleUrl: './agreement-page.component.scss'
})
export class AgreementPageComponent implements OnInit {
    protected readonly APP_ROUTES = APP_ROUTES;
    protected readonly NAVS = NAVS;
    template!: Template;

    constructor(
        private route: ActivatedRoute,
        private seoService: SeoService,
    ) {
    }

    ngOnInit() {
        this.template = new Template(this.route.snapshot.data['content']);

        if (this.template) {
            this.seoService.applyTemplate(this.template, {
                path: APP_ROUTES.AGREEMENT.INDEX,
                robots: this.template.data.page.indexed === false ? 'noindex,nofollow' : undefined,
                breadcrumb: [
                    {name: NAVS.INDEX, path: APP_ROUTES.INDEX},
                    {name: this.template.data.page.breadcrumb, path: APP_ROUTES.AGREEMENT.INDEX},
                ],
            });
        }
    }

    protected readonly env = env;
}
